import { API_BASE_PATH } from "@teamna/shared";

/**
 * Where the API lives.
 *
 * Same origin by default, because in production this SPA is served by the Desk API itself (desk.teamna.app).
 * `VITE_API_URL` overrides it, which is what you set when a phone on the office wifi has to reach a
 * laptop, or when the built app is opened from somewhere other than the API host.
 *
 * Kept in its own module so the auth store and the request client can both read it without either
 * importing the other.
 */

const CONFIGURED = (import.meta.env.VITE_API_URL ?? "").trim().replace(/\/+$/, "");

export function apiOrigin(): string {
  if (CONFIGURED.length > 0) return CONFIGURED;
  if (typeof window === "undefined") return "";
  return window.location.origin;
}

/** The `/v1` prefix every endpoint path in this app is relative to. */
export function apiBaseUrl(): string {
  return `${apiOrigin()}${API_BASE_PATH}`;
}
